import React from "react";
import { twMerge } from "tailwind-merge";
import { LabelProps } from "./type.ts";

const Label: React.FC<LabelProps> = ({
  id,
  className,
  children,
  variant = "primary",
  required = false,
}) => {
  const fontStyles = {
    primary: "text-gray-200",
    secondary: "text-gray-350",
  };
  return (
    <label
      htmlFor={id}
      className={twMerge(
        "block px-1 text-sm font-normal",
        fontStyles[variant],
        required && 'after:pl-2 after:text-red-500 after:content-["*"]',
        className
      )}
    >
      {children}
    </label>
  );
};

export default Label;
